<template>
	<div>
		<row-detail-modal
			v-if="openModal === 'detailModal'"
			:module-slug="detailModal.relatedModule.slug"
			:id="detailModal.id"
			@cancel="() => openModal = null"
		></row-detail-modal>
	</div>
</template>

<script>

import RowDetailModal from '@/views/sections/app/modules/modals/RowDetailModal';

export default {

	data() {
		return {
			detailModal: {},
			openModal: null,
		};
	},

	watch: {
		$route: function() {
			this.openModal = null;
		},
	},

	mounted() {
		document.addEventListener('keyup', (e) => {
			if (e.key === 'Escape') {
				this.openModal = null;
			}
		});

		this.$root.$on('open-modal', (modal) => {
			if (typeof this[modal.type] !== 'undefined') {
				this[modal.type] = modal;
				this.openModal = modal.type;
			}
		});
	},

	components: {
		RowDetailModal,
	},

};

</script>
